export async function getOptions(booking:Booking) {
    console.log('get-options.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'options';

    let data = new FormData();
    data.append('action', 'react_data');
    data.append('call', 'options');
    data.append('booking', JSON.stringify(booking));

    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return {error:error}
            }
        );
}
